import { createFileRoute } from '@tanstack/react-router'

import ApbnPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/containers/ApbnPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/apbn/')({
  component: ApbnPage
})
